var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatoBancarioClientePagadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7a1a1d;}.cls-2{fill:#5d646f;}.cls-3{fill:#211915;}.cls-4{fill:#be4047;}.cls-5{fill:#d2dde6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.87,38.7H81a3.38,3.38,0,0,1,3.38,3.38V72.5A3.38,3.38,0,0,1,81,75.88H26.87a3.38,3.38,0,0,1-3.38-3.38V42.08A3.38,3.38,0,0,1,26.87,38.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.05,69.12h54.08a3.38,3.38,0,0,1,3.38,3.38v30.42a3.38,3.38,0,0,1-3.38,3.38H64.05a3.38,3.38,0,0,1-3.38-3.38V72.5A3.38,3.38,0,0,1,64.05,69.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.25,45.46H40.39v6.76H30.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.57,47.15H60.67a1.69,1.69,0,0,1,0-3.38h16.9a1.69,1.69,0,0,1,0,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.57,53.91H53.91a1.69,1.69,0,0,1,0-3.38H77.57a1.69,1.69,0,1,1,0,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.91,70.81H30.25a1.69,1.69,0,0,1,0-3.38H53.91a1.69,1.69,0,1,1,0,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.25,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,30.25,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,0,1,3.38,0v1.69A1.69,1.69,0,0,1,37,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.77,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,43.77,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.53,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,50.53,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.6,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,55.6,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.36,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,62.36,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.12,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,69.12,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.88,64.05a1.69,1.69,0,0,1-1.69-1.69V60.67a1.69,1.69,0,1,1,3.38,0v1.69A1.69,1.69,0,0,1,75.88,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.67,79.26h60.84V86H60.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatoBancarioClientePagadora);
export default __webpack_public_path__ + "static/media/dato_bancario_cliente_pagadora.cf7a61070ccf639cbfce9a54e06f98aa.svg";
export { ForwardRef as ReactComponent };